import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Chip, Avatar, Typography, Switch, CircularProgress, InputAdornment, TextField, IconButton } from '@mui/material';
import ApiService from '../../functions/apiService';
import MyTable from '../../components/Schedule/MyTable';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import './attribute-manage.css'
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import editIcon from "../../assets/edit.svg";

const EntityManagement = () => {
	const { user } = useContext(AuthContext)
	const [loading, setLoading] = useState(false);
	const [listType, setListType] = useState('Entity Management')
	const [title, setTitle] = useState('');
	const [deleteModal, setDeleteModal] = useState(false)
	const [entityList, setEntityList] = useState('');
	const [searchResult, setSearchResult] = useState('');
	const [deleteId, setDeleteId] = useState('');
	const [updateId, setUpdateId] = useState('');
	const [isEdit, setIsEdit] = useState(false);

	const columns = [
		{
			field: 'name', headerName: 'Entity Name', flex: 1, minWidth: 130,
			valueGetter: (params) => { return params?.row?.name }
		},

		{
			field: 'updateStatus', headerName: 'Status', flex: 1, minWidth: 80,
			renderCell: (params) => {
				return (

					<div>
						<Switch
							checked={params?.row?.is_active == 1}
							onChange={() => updateEntityStatus(params?.row?.id, params?.row?.is_active)}
							color="primary"
						/>
					</div>
				)
			}
		},

		{
			field: 'created_at', headerName: 'Created at', flex: 1, minWidth: 200,
			valueGetter: (params) => { return varFormatTime(params?.row?.created_at, user?.Time_Format) }
		},

		// {
		// 	field: 'attributes', headerName: 'Attributes', flex: 1, minWidth: 130,
		// 	renderCell: (params) => {
		// 		return (
		// 			<Chip
		// 				variant="outlined"
		// 				sx={{
		// 					backgroundColor: '#EAECF0',
		// 					color: '#2B3F6C',
		// 					border: '1px solid #2B3F6C',
		// 					cursor: 'pointer'
		// 				}}
		// 				avatar={<Avatar src="/images/eye.png" style={{ width: 28, height: 24, padding: 2 }} />}
		// 				label={'View'}
		// 			// onClick={() => {}}
		// 			/>)
		// 	}
		// },

		{
			field: 'action', headerName: 'Actions', flex: 1, maxWidth: 130,
			renderCell: (params) => {
				return (
					<Box sx={{ display: 'flex', gap: 1 }}>
						<img src={editIcon} alt="editIcon" style={{ width: '20px', cursor: 'pointer' }}
							onClick={() => {
								setUpdateId(params?.row?.id)
								setIsEdit(true)
								window.scrollTo(1, 1)
								updateEntityData(params?.row?.id)
							}}
						/>
						<img src='/images/delete.svg' style={{ cursor: 'pointer' }}
							onClick={() => {
								setDeleteModal(true)
								setDeleteId(params?.row?.id)
							}}
						/>
					</Box>
				);
			},
		}
	]

	const getEntityList = (loader = true) => {
		if (loader) {
			setLoading(true);
		}
		const body = {
			"search": searchResult
		}
		ApiService.post('/inventory/entities', body)
			.then((data) => {
				setEntityList(data?.data);
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			});
	};

	const addEntity = () => {
		const body = {
			'name': title,
			'search': searchResult
		}
		ApiService.post('/inventory/entity/create', body)
			.then((data) => {
				toast.success(data?.message)
				setTitle('');
				getEntityList()
			})
			.catch(({data}) => {
				toast.error(data?.message)
			})
	}

	const updateEntityData = (id) => {
		ApiService.get('/inventory/entity/' + id)
			.then(({ data }) => {
				setLoading(false);
				setTitle(data?.data?.name)
				getEntityList()
			})
			.catch(({ response }) => {
				console.error(response?.data?.message)
			})
	}

	const updateEntity = () => {
		const body = {
			'name': title,
			'entity_id': updateId
		}
		ApiService.post('/inventory/entity/update', body)
			.then((data) => {
				toast.success(data?.message)
				setTitle('');
				setIsEdit(false)
				getEntityList()
			})
			.catch((error) => {
				toast.error(error.message)
			})
	}

	const deleteEntity = () => {
		ApiService.get(`/inventory/entity/delete/${deleteId}`)
			.then(({ data }) => {
				setDeleteModal(false)
				toast.success(data?.message)
				getEntityList()
			})
			.catch(({ response }) => {
				toast.error(response?.data?.message)
			})
	}

	const updateEntityStatus = (id, currStatus) => {
		const body = {
			"entity_id": id,
			"status": currStatus == 1 ? 'false' : 'true'
		}
		ApiService.post('/inventory/entity/status', body)
			.then((data) => {
				getEntityList(false)
				toast.success(data?.message)
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	useEffect(() => {
		getEntityList()
	}, [])

	useEffect(() => {
		getEntityList(false)
	}, [searchResult])

	return (
		<>
			<Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
				<Grid container spacing={2} className='align-items-center'>

					{/* Heading */}
					<Grid item xs={10} md={4}>
						<Typography variant="h5">Entity Management</Typography>
					</Grid>

					{/* Attribute Management Button */}
					<Grid item xs={6} sm={6} md={'auto'}>
						<Link to='/firehouse/attribute-management' style={{ textDecoration: 'none' }}>
							<div className={listType == 'Attribute Management' ? 'tab-active px-4' : 'tab-white px-4'}
								onClick={() => setListType('Attribute Management')}>
								Attribute Management
							</div>
						</Link>
					</Grid>

					{/* Entity Management Button */}
					<Grid item xs={6} sm={6} md={'auto'}>
						<Link to='/firehouse/entity-management' style={{ textDecoration: 'none' }}>
							<div className={listType == 'Entity Management' ? 'tab-active px-4' : 'tab-white px-4'}
								onClick={() => setListType('Entity Management')}>
								Entity Management
							</div>
						</Link>
					</Grid>

					<Grid container className='p-4' spacing={2}>
						{/* Entity Name */}
						<Grid item xs={12} sm={6} md={4}>
							<label className='my-2'>Entity Name</label>
							<TextField
								fullWidth
								variant="outlined"
								onChange={(e) => setTitle(e.target.value)}
								value={title}
								placeholder="Enter Name"
								sx={{
									"& .MuiInputBase-root": {
										height: "48px",
										fontSize: "14px",
										display: "flex",
										alignItems: "center"
									}
								}} />
						</Grid>
					</Grid>

					{/* Submit Button */}
					<Grid container gap={2} className='justify-content-end'>
						<Grid item xs={6} md={'auto'}>
							<ButtonTheme type='submit' variant="filled" color='primary' className='px-2 mt-1' style={{ marginRight: '24px', width: '100px' }}
								onClick={() => {
									if (isEdit == true)
										updateEntity()
									else
										addEntity()
								}}>
								{isEdit == true ? "Update" : "Save"}
							</ButtonTheme>
						</Grid>
					</Grid>
				</Grid>
			</Paper>

			{loading ? (
				<Paper className="w-100 h-100 p-4 d-flex justify-content-center align-items-center font-fam" style={{ marginTop: "1rem" }}>
					<CircularProgress />
				</Paper>
			) : (
				<Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
					<Grid container spacing={2}>

						{/* Heading */}
						<Grid item xs={10} md={9}>
							<Typography variant="h5">List of Entities</Typography>
						</Grid>

						{/* Search field */}
						<Grid item xs={12} sm={12} md={3}>
							<TextField
								variant="outlined"
								placeholder="Search"
								onChange={(e) => setSearchResult(e.target.value)}
								className="w-100"
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton>
												<SearchIcon />
											</IconButton>
										</InputAdornment>
									),
									sx: {
										height: '48px',
										fontSize: '14px',
										marginRight: '10px',
									},
								}}
							/>
						</Grid>

					</Grid>

					{(!entityList || entityList.length == 0) ?
						<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 325 }}>
							<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
							<span className='mt-4' style={{ color: '#555555' }}>
								No Entities Found
							</span>
						</div>
						:
						<div className='mt-4'>
							<MyTable
								rows={entityList}
								columns={columns}
								checkboxSelection={false}
								hideFooter={true}
							/>
						</div>}

					{/* Delete Modal */}
					<Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
						<Modal.Header closeButton>
							<Modal.Title>Delete Entity</Modal.Title>
						</Modal.Header>

						<Modal.Body>
							<div style={{ color: '#555555' }}>
								Are you sure you want to delete this Entity?
							</div>
							<Row>
								<Col md='auto'>
									<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
										setDeleteModal(false)
									}}>
										Cancel
									</ButtonTheme>
								</Col>

								<Col md='auto'>
									<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
										onClick={deleteEntity}
									>
										Delete
									</ButtonTheme>
								</Col>

							</Row>
						</Modal.Body>
					</Modal>
				</Paper >
			)}
		</>
	)
}

export default EntityManagement